import React from 'react';
import {paths} from '../../common/dictionaries/urls';
import AnticipatedInvoiceVehiclesSelection from './selection';
import AnticipatedInvoiceVehiclesValidation from './validation';

export const anticipatedInvoiceVehiclesRoutes = [
  {'component': <AnticipatedInvoiceVehiclesSelection />, 'path': paths.AnticipatedInvoiceVehiclesSelection},
  {'component': <AnticipatedInvoiceVehiclesValidation />, 'path': paths.AnticipatedInvoiceVehiclesValidation},
];

